import AuthService from '@forwardflow/services/AuthService'
import { Button, TextField } from '@forwardflow/ui'
import { Form } from 'antd'
import { useState } from 'react'

type ForgotPasswordFormProps = {
   onSubmit: (submitted: boolean, email?: string) => void
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
   onSubmit,
}) => {
   const [isLoading, setLoading] = useState<boolean>(false)

   const [form] = Form.useForm()

   const handleSubmit = async () => {
      try {
         setLoading(true)
         const values = await form.validateFields()
         const response = await AuthService.apiForgotPassword(
            window.location.origin + '/set-new-password',
            values.email
         )

         if (response.success === false) {
            form.setFields([{
               name: 'email',
               errors: ['User not found with this email address.']
            }]);
            return;
         }
         
         onSubmit(true, values.email)
      } catch (error: any) {
         console.error('error', error)
         onSubmit(false)
      } finally {
         setLoading(false)
      }
   }
   return (
      <>
         <Form
            layout="vertical"
            form={form}
            initialValues={{}}
            onFinish={handleSubmit}
            className="w-full text-left text-white max-w-[450px]"
            autoComplete="off"
         >
            <TextField
               name="email"
               label="Email"
               formItemClassName="w-full ff-white-label"
               placeholder="Enter your email"
               isRequired
               validateEmail
               errorMessage="Please enter a valid email"
            />

            <Button
               isLoading={isLoading}
               type="submit"
               className="!mt-8 mb-10 h-[60px]"
            >
               Reset Password
            </Button>
         </Form>
      </>
   )
}
